@import '_base.css';

:root {
  --spw-ds-primary: var(--spw-color-themes-red-red-500);
  --spw-ds-variant: var(--spw-color-themes-red-red-700);
  --spw-ds-active: var(--spw-color-themes-red-red-800);
  --spw-ds-cta-outlined-bg-hover: var(--spw-color-themes-red-red-50);
  --spw-ds-cta-outlined-stroke-hover: var(--spw-color-themes-red-red-700);
  --spw-ds-cta-outlined-bg-active: var(--spw-color-themes-red-red-100);
  --spw-ds-cta-outlined-stroke-active: var(--spw-color-themes-red-red-800);
}
